import React from 'react';
import axios from './../../../constants/axios';
import { Button } from 'react-bootstrap';
import ContactGeneralEditForm from './ContactGeneralEditForm';
import './ContactGeneral.less';

class ContactGeneral extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         general: {},
         showForm: false
      };
   }

   componentDidMount() {
      const { contactId } = this.props;
      axios.get(`/contacts/getGeneralById/${contactId}`)
         .then((res) => {
            this.setState({
               general: res.data
            });
         });
   }

   toggleShowForm = () => {
      this.setState({
         showForm: !this.state.showForm
      });
   };

   updateGeneral = (values) => {
      this.setState({
         general: values,
         showForm: false
      });
   };

   render() {
      const { general, showForm } = this.state;
      return (
         <div className="row ContactGeneral" >
            <div className="mart71_info" >
               <h1>Mart71.com</h1>
               <h1>01910 717171, 01519 717171</h1>
            </div>
            <div className="col-md-6" >
               <h4>
                  Contact General
                  {" "}
                  {showForm === false && <Button onClick={this.toggleShowForm} >Edit</Button>}
               </h4>

               <hr/>
               <p>Name: {general.name}</p>
               <p>Mobile: {general.mobile}</p>
               <p>Email: {general.email}</p>
               <p>Contact Type: {general.contact_type}</p>
               <p>Active: {general.active ? 'Yes' : 'No'}</p>
            </div>
            <div className="col-md-6" >
               {showForm === true &&
               <ContactGeneralEditForm updateGeneral={this.updateGeneral} toggleShowForm={this.toggleShowForm}
                                       general={general} />
               }
            </div>
         </div>

      );
   }
}

ContactGeneral.propTypes = {
   contactId: React.PropTypes.object
};

export default ContactGeneral;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactGeneral.js
 **/